// AI-ASSISTED: generated with claude-code (Opus 4.8) on 2026-09-14, reviewed by Yoann Hertienne
//
// Global Release Feed (spec 004-release-feed) frontend module. Registers the
// /releases feed page via PageBlueprint (mirrors modules/maintenance/index.tsx).
// The flag-aware sidebar entry is added in modules/nav/Sidebar.tsx.
//
// React Router ranks the static /releases/coverage above the dynamic
// /releases/:component, so the two do not collide.
import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';

export const releasesPageModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    PageBlueprint.make({
      name: 'releases-feed',
      params: {
        path: '/releases',
        loader: async () => {
          const { ReleaseFeedPage } = await import('./ReleaseFeedPage');
          return <ReleaseFeedPage />;
        },
      },
    }),
    PageBlueprint.make({
      name: 'releases-coverage',
      params: {
        path: '/releases/coverage',
        loader: async () => {
          const { CoveragePage } = await import('./CoveragePage');
          return <CoveragePage />;
        },
      },
    }),
    PageBlueprint.make({
      name: 'releases-component-history',
      params: {
        path: '/releases/:component',
        loader: async () => {
          const { ComponentHistoryPage } = await import('./ComponentHistoryPage');
          return <ComponentHistoryPage />;
        },
      },
    }),
  ],
});

// Entity-page entry point (DPT-594, FR-013): a flag-gated card on the Component
// catalog entity page linking to that component's release history. Registered
// under the `catalog` plugin (mirrors modules/app-insights-card/), so it must be
// added to App.tsx `features` separately from the page module above.
export const releasesEntityCardModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    EntityCardBlueprint.make({
      name: 'release-history',
      params: {
        filter: 'kind:component',
        loader: async () => {
          const { ReleaseHistoryCard } = await import('./ReleaseHistoryCard');
          return <ReleaseHistoryCard />;
        },
      },
    }),
  ],
});
